'use client'

import Link from 'next/link'
import { usePathname, useRouter } from 'next/navigation'
import type { ReactNode } from 'react'
import type { DocsLocale } from '@/lib/docs-i18n'
import { getDocsBasePath } from '@/lib/docs-locale'

/** "/ Docs" — always lands on docs home and revalidates, even when already there. */
export function DocsSectionLink({
  locale,
  className,
  children,
}: {
  locale: DocsLocale
  className?: string
  children: ReactNode
}) {
  const router = useRouter()
  const pathname = usePathname()
  const href = getDocsBasePath(locale)

  function handleClick(event: React.MouseEvent<HTMLAnchorElement>) {
    event.preventDefault()
    const onHome = pathname === href || pathname === `${href}/`
    if (onHome) {
      router.refresh()
      return
    }
    router.push(href)
    router.refresh()
  }

  return (
    <Link href={href} onClick={handleClick} className={className}>
      {children}
    </Link>
  )
}
